import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from "@mui/material";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { useContext } from "react";

import { FairPaySurveyResponse } from "features/FairPaySurvey/schemas";
import { formatLabel } from "utils/string";
import { makeDeepCopy } from "utils/updateLocalState";

const styles = {
  selectContainer: {
    boxShadow: "none",
    border: "1px black solid",
    borderRadius: 4,
    mb: 2,
  },
  selectLabel: {
    fontSize: 14,
    opacity: 0.5,
  },
  selected: {
    py: 1,
    px: 3,
    backgroundColor: "yellow.main",
    borderRadius: 4,
  },
  unselected: {
    py: 1,
    px: 3,
    backgroundColor: "white",
  },
};

interface Props {
  label?: JSX.Element | string;
  options: any[];
  selectedOption: string | number | any;
  name: keyof FairPaySurveyResponse;
  required?: boolean;
  isCurrency?: boolean;
}

const FairPaySelect = ({
  label,
  options,
  name,
  selectedOption,
  required = false,
  isCurrency = false,
}: Props) => {
  const { fairPaySurveyResponse, setFairPaySurveyResponse } = useContext(
    FairPaySurveyResponseContext,
  );

  const handleClickOption = (
    name: keyof FairPaySurveyResponse,
    option: string | number | any,
  ) => {
    if (!fairPaySurveyResponse) return;
    const exists = fairPaySurveyResponse[name] === option;
    setFairPaySurveyResponse((prev) => {
      const copy = makeDeepCopy(prev) || {};
      copy[name] = exists ? null : option;
      return copy;
    });
  };

  return (
    <Accordion square={true} sx={styles.selectContainer} defaultExpanded>
      <AccordionSummary
        expandIcon={
          <Box component="i" className="fa-regular fa-chevron-down" />
        }
        sx={styles.selectLabel}
      >
        {label ? label : "Select an option"} {required ? "*" : ""}
      </AccordionSummary>
      <AccordionDetails>
        {options.map((option: any) => (
          <Box
            key={option}
            sx={selectedOption === option ? styles.selected : styles.unselected}
            onClick={(e) => {
              e.stopPropagation();
              handleClickOption(name, option);
            }}
          >
            {formatLabel(option, isCurrency)}
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default FairPaySelect;
